import axios from 'axios';
import store from '../../store/index';

if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = '/api/';
} else {
    // axios.defaults.baseURL = 'http://8c1a09ce44a4.sn.mynetname.net:3339/api/';
    axios.defaults.baseURL = 'http://localhost:3333/api/';
    // axios.defaults.baseURL = 'http://192.168.200.253:3333/api/';
}

const success = res => res;
const error = err => {
    let intercepted = false;
    
    if (err.code === "ERR_NETWORK") {
        store.dispatch("showErrorSnack", "Sem conexão com o servidor");
        intercepted = true;
        return Promise.reject({ intercepted, error: err });
    }

    switch (err.response?.status) {
        case 401:
            store.commit('destroyUser')
            if (err.response?.data?.error) {
                store.dispatch("showErrorSnack", err.response.data.error);
                intercepted = true;
            }
            break;
        case 500:
            store.dispatch("showErrorSnack", "Erro no servidor");
            console.log(JSON.stringify(err.response.data));
            intercepted = true;
            break;
        default:
            if (err.response?.data?.error) {
                store.dispatch("showErrorSnack", err.response.data.error);
                intercepted = true;
            }
            break;
    }
    return Promise.reject({ intercepted, error: err });
}

axios.interceptors.response.use(success, error);

export default axios;